import { React, useState } from "react";
import styles from "./Budget.module.scss";
import "./calendar.scss";
import classNames from "classnames";
import _ from "../../i18n";
import moment from "moment";

import { DatePicker, Switch } from "antd";
import TextArea from "antd/lib/input/TextArea";

const YesNoSwitch = ({ checked, onChange }) => (
  <div className={styles.yes_no_switch}>
    <button
      className={`${styles.switch_button} ${checked ? styles.active_yes : styles.active_no}`}
      onClick={() => onChange(!checked)}
    >
      <span className={`${styles.option} ${checked ? styles.active_yes : ''}`}>Oui</span>
      <span className={`${styles.option} ${!checked ? styles.active_no : ''}`}>Non</span>
    </button>
  </div>
);

const Settings = ({
  categories,
  dataSettings,
  newClient,
  setNewClient,
  departClient,
  setDepartClient,
  atRiskClient,
  setAtRiskClient,
  setUpdated,
  preferentialTariff,
  setPreferentialTariff,
  setNormalVoyant,
  setMediumVoyantFrom,
  setMediumVoyantTo,
  setHighVoyant,
  normalVoyant,
  mediumVoyantFrom,
  mediumVoyantTo,
  highVoyant,
}) => {
  const [selectedTab, setSelectedTab] = useState("NewClient");
  const [isPreferentialTariffChecked, setIsPreferentialTariffChecked] =
    useState(preferentialTariff !== 0);

  const handleChangeValues = (rowIndex, column, list) => {
    if (list === "start") {
      setNewClient((prevNewClient) => ({
        ...prevNewClient,
        startCategories: prevNewClient.startCategories.map((item, index) => {
          if (index === rowIndex) {
            return {
              ...item,
              [column]: !item.checked,
            };
          } else {
            return item;
          }
        }),
      }));
    } else {
      setDepartClient((prevDepartClient) => ({
        ...prevDepartClient,
        departCategories: prevDepartClient.departCategories.map((item, index) => {
          if (index === rowIndex) {
            return {
              ...item,
              [column]: !item.checked,
            };
          } else {
            return item;
          }
        }),
      }));
    }
    setUpdated(true);
  };

  const renderActiveSettingContent = () => {
    switch (selectedTab) {
      case "NewClient":
        return (
          <>
            <div className={styles.settings}>
              <div className={styles.title_settings}>Nouveau client</div>
              <div>
                <div className={styles.calendar_content}>
                  <div className={styles.date_title}>Début de facturation</div>
                  <DatePicker
                    className="calendar_input"
                    format="DD/MM/YYYY"
                    value={newClient.startFacturationDate || moment()}
                    locale="fr"
                    allowClear={false}
                    placeholder="Selectionner une date"
                    popupClassName="datepicker_popup"
                    onSelect={(date) => {
                      if (moment(date).isValid()) {
                        setNewClient(prevNewClient => ({
                          ...prevNewClient,
                          startFacturationDate: date
                        }));
                      } else {
                        setNewClient(prevNewClient => ({
                          ...prevNewClient,
                          startFacturationDate: moment()
                        }));
                      }
                    }}
                  />
                </div>
                <div className={styles.calendar_content}>
                  <div className={styles.date_title}>Début de prestation</div>
                  <DatePicker
                    className="calendar_input"
                    format="DD/MM/YYYY"
                    value={newClient.startTaskDate || moment()}
                    locale="fr"
                    allowClear={false}
                    placeholder="Selectionner une date"
                    popupClassName="datepicker_popup"
                    onSelect={(date) => {
                      if (moment(date).isValid()) {
                        setNewClient(prevNewClient => ({
                          ...prevNewClient,
                          startTaskDate: date
                        }));
                      } else {
                        setNewClient(prevNewClient => ({
                          ...prevNewClient,
                          startTaskDate: moment()
                        }));
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={styles.categories_list}>
              <div className={styles.categories}>
                categories
                <div>
                  {newClient.startCategories.map((item, i) => {
                    return (
                      <div className={styles.category_item}>
                        <span>{item.label}</span>
                        <div className={styles.switch}>
                          <Switch
                            checked={item.checked}
                            onChange={() =>
                              handleChangeValues(i, "checked", "start")
                            }
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </>
        );
      case "AtRisk":
        return (
          <>
            <div
              className={styles.settings}
              style={{ height: "100%", width: "100%" }}
            >
              <div className={styles.title_settings}>Client à risque</div>
              <div>
                <div className={styles.date_title}>Remarque</div>
                <TextArea
                  style={{ resize: "none", width: "100%" }}
                  rows={7}
                  value={atRiskClient.leavingRiskObservation}
                  onChange={(e) =>
                    setAtRiskClient(prevState => ({
                      ...prevState,
                      leavingRiskObservation: e.target.value
                    }))
                  }
                />
              </div>
            </div>
          </>
        );
      case "Depart":
        return (
          <>
            <div className={styles.settings}>
              <div className={styles.title_settings}>Depart client</div>
              <div>
                <div className={styles.yes_no_switch_container}>
                  <span className={styles.switch_title}>Récupéré?</span>
                  <YesNoSwitch
                    checked={departClient.recovered === 1}
                    onChange={(checked) =>
                      setDepartClient(prevState => ({
                        ...prevState,
                        recovered: checked ? 1 : 0
                      }))
                    }
                  />
                </div>
                <div className={styles.calendar_content}>
                  <div className={styles.date_title}>Fin de facturation</div>
                  <DatePicker
                    className="calendar_input"
                    format="DD/MM/YYYY"
                    value={departClient.departFacturationDate || moment()}
                    locale="fr"
                    allowClear={false}
                    placeholder="Selectionner une date"
                    popupClassName="datepicker_popup"
                    onSelect={(date) => {
                      if (moment(date).isValid()) {
                        setDepartClient(prevState => ({
                          ...prevState,
                          departFacturationDate: date
                        }));
                      } else {
                        setDepartClient(prevState => ({
                          ...prevState,
                          departFacturationDate: moment()
                        }));
                      }
                    }}
                  />
                </div>
                <div className={styles.calendar_content}>
                  <div className={styles.date_title}>Fin de prestation</div>
                  <DatePicker
                    className="calendar_input"
                    format="DD/MM/YYYY"
                    value={departClient.departTaskDate || moment()}
                    locale="fr"
                    allowClear={false}
                    placeholder="Selectionner une date"
                    popupClassName="datepicker_popup"
                    onSelect={(date) => {
                      if (moment(date).isValid()) {
                        setDepartClient(prevState => ({
                          ...prevState,
                          departTaskDate: date
                        }));
                      } else {
                        setDepartClient(prevState => ({
                          ...prevState,
                          departTaskDate: moment()
                        }));
                      }
                    }}
                  />
                </div>
                <div className={styles.calendar_content}>
                  <div className={styles.date_title}>Date de depart</div>
                  <DatePicker
                    className="calendar_input"
                    format="DD/MM/YYYY"
                    value={departClient.communicatedDeparture || moment()}
                    locale="fr"
                    allowClear={false}
                    placeholder="Selectionner une date"
                    popupClassName="datepicker_popup"
                    onSelect={(date) => {
                      if (moment(date).isValid()) {
                        setDepartClient(prevState => ({
                          ...prevState,
                          communicatedDeparture: date
                        }));
                      } else {
                        setDepartClient(prevState => ({
                          ...prevState,
                          communicatedDeparture: moment()
                        }));
                      }
                    }}
                  />
                </div>
              </div>
            </div>
            <div className={styles.categories_list}>
              <div className={styles.categories}>
                categories
                <div>
                  {departClient.departCategories.map((item, i) => {
                    return (
                      <div className={styles.category_item}>
                        <span>{item.label}</span>
                        <div className={styles.switch}>
                          <Switch
                            checked={item.checked}
                            onChange={() =>
                              handleChangeValues(i, "checked", "depart")
                            }
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div className={styles.title}>Paramètre client</div>
      <div className="grid-x">
        <div className="cell small-4 medium-4 large-3">
          <div
            className={classNames(
              styles.group_info,
              selectedTab === "NewClient" && styles.selected_info
            )}
            onClick={() => setSelectedTab("NewClient")}
          >
            <div className={styles.info}>
              <div className={styles.info_content}>
                <span>Nouveau client :</span>
                <div>
                  <Switch
                    checked={newClient.activated}
                    onChange={() =>
                      setNewClient(prevState => ({
                        ...prevState,
                        activated: !prevState.activated
                      }))
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className={classNames(
              styles.group_info,
              selectedTab === "AtRisk" && styles.selected_info
            )}
            onClick={() => setSelectedTab("AtRisk")}
          >
            <div className={styles.info}>
              <div className={styles.info_content}>
                <span>Client à risk :</span>
                <div>
                  <Switch
                    checked={atRiskClient.activated}
                    onChange={() =>
                      setAtRiskClient(prevState => ({
                        ...prevState,
                        activated: !prevState.activated
                      }))
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            className={classNames(
              styles.group_info,
              selectedTab === "Depart" && styles.selected_info
            )}
            onClick={() => setSelectedTab("Depart")}
          >
            <div className={styles.info}>
              <div className={styles.info_content}>
                <span>Départ client :</span>
                <div>
                  <Switch
                    checked={departClient.activated}
                    onChange={() =>
                      setDepartClient(prevState => ({
                        ...prevState,
                        activated: !prevState.activated
                      }))
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          {/* {(preferences.allowUpdatingTarifClients==="1") && (
            <div
              className={classNames(
                styles.group_info,
                selectedTab === "PreferentialTariff" && styles.selected_info
              )}
              onClick={() => setSelectedTab("PreferentialTariff")}
            >
              <div className={styles.info}>
                <div className={styles.info_content}>
                  <span>Tarif préférentiel/ friendzone :</span>
                  <div>
                    <Switch
                      checked={isPreferentialTariffChecked}
                      onChange={() => setIsPreferentialTariffChecked(!isPreferentialTariffChecked)}
                    />
                  </div>
                </div>
              </div>
            </div>
          )} */}
          <div className={styles.info}>
            <div className={styles.info_content}>
              <span>Relations liées :</span>
              {dataSettings.attached.length > 0 &&
                dataSettings.attached.map((item, i) => {
                  return <div>{item.name}</div>;
                })}
            </div>
          </div>

            <div className={styles.info} style={{ height: "auto" }}>
              <div className={styles.info_content}>
                <span>Voyant de facturation :</span>
                <div className={styles.voyant_goup}>
                  <span
                    className={styles.span}
                    style={{ background: "#06D9B1" }}
                  ></span>
                  <div className={styles.voyant}>
                    {"< "}
                    <input
                      type="number"
                      style={{ width: "46px" }}
                      className={classNames(styles.input)}
                      value={normalVoyant}
                      onChange={(event) => setNormalVoyant(event.target.value)}
                    />
                    {" %"}
                  </div>
                </div>
                <div className={styles.voyant_goup}>
                  <span
                    className={styles.span}
                    style={{ background: "#EA8124" }}
                  ></span>{" "}
                  <div className={styles.voyant}>
                    {"de "}
                    <input
                      type="number"
                      style={{ width: "46px" }}
                      className={classNames(styles.input)}
                      value={mediumVoyantFrom}
                      onChange={(event) =>
                        setMediumVoyantFrom(event.target.value)
                      }
                    />
                    {" %"}
                  </div>
                  <div className={styles.voyant}>
                    {"a "}
                    <input
                      type="number"
                      style={{ width: "46px" }}
                      className={classNames(styles.input)}
                      value={mediumVoyantTo}
                      onChange={(event) =>
                        setMediumVoyantTo(event.target.value)
                      }
                    />
                    {" %"}
                  </div>
                </div>
                <div className={styles.voyant_goup}>
                  <span
                    className={styles.span}
                    style={{ background: "#EB5757" }}
                  ></span>{" "}
                  <div className={styles.voyant}>
                    {" > "}
                    <input
                      type="number"
                      style={{ width: "46px" }}
                      className={classNames(styles.input)}
                      value={highVoyant}
                      onChange={(event) => setHighVoyant(event.target.value)}
                    />
                    {" %"}
                  </div>
                </div>
              </div>
            </div>

        </div>
        {selectedTab !== "" && (
          <div
            className={classNames("cell small-4 medium-4 large-9")}
            style={{}}
          >
            <div
              className={styles.line}
              style={{
                display: "flex",
                height: "100%",
              }}
            >
              {renderActiveSettingContent()}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Settings;
